import React, {useEffect, useMemo, useState, useLayoutEffect} from 'react';
import {Platform, TouchableOpacity, View} from 'react-native';
import {CardInfo} from '../../../../../shared/components/cardInfo';
import Screen from '../../../../../shared/components/screen';
import {Table} from '../../../../../shared/components/table';
import {Column} from '../../../../../shared/components/table/model';
import {Text} from '../../../../../shared/components/text';
import {dateFormats} from '../../../../../shared/constants/date';
import {useStyles} from '../../../../../shared/hooks/styles';
import {ProvidingListApplication} from '../../../../../shared/models/api';
import {ProfileApplicationsStatus} from '../../../../../shared/models/profile/applications';
import {datePipe} from '../../../../../shared/pipes';
import {useTheme} from '../../../../../shared/theme';
import {stylePatterns} from '../../../../../shared/theme/patterns';
import {ApplicationsFilterDesktop} from '../applicationsFilter';
import {Button} from '../../../../../shared/components/button';
import {IStateProps} from './model';
import {ApplicationsFilterVisuallyImpaired} from '../applicationsFilterVisuallyImpaired';
import {capitalize} from '../../../../../shared/utils/text';
import {ContentWithRightImage} from '../../../../../shared/components/contentWithRightImage';
import {useModal} from '../../../../../shared/components/modal';
import {Modal} from '../../../../../shared/components/modal/modal';
import {useDispatch, useSelector} from 'react-redux';
import {UserCardList} from '../../../../login/esiaRegCard/components/form/components/userCardList/view';
import {esiaLinkSelector, esiaRegistrationInfoSelector} from '../../../../../redux/selectors/login';
import {useRegCardState} from '../../../../login/esiaRegCard/esiaRegCardState/useRegCardState';
import {CustomScrollView} from '../../../../../shared/components/scrollView';
import {EsiaRegCardFormScreen} from '../../../../login/esiaRegCard/components/form';
import {getEsiaLink} from '../../../../../redux/actions/login';
import {EsiaRegCardMap} from '../../../../login/esiaRegCard/components/map';
import {useNavigation} from '@react-navigation/native';
import {loginSlice} from '../../../../../redux/reducers/login';
import {ContentWithRightImageDesktopProfile} from '../contentWithRightImageDesktopProfile';
import {destroy} from 'redux-form';
import {store} from '../../../../../redux';
import {showLoaderSlice} from '../../../../../redux/reducers/loader/showLoader';
import {clearLoadingState, saveLoadingState} from '../../../../../shared/utils/loadingStateLocalStorage';

export enum EsiaRegStep {
  UsersList,
  Form,
  DeliveryType,
}

export default ({onPressItem, onLoadMore, applications, allShown, onApplyFilter, isVisuallyImpaired}: IStateProps) => {
  const _theme = useTheme();
  const styles = useStyles(({theme}) => ({
    h2: theme.fonts.h2,
    container: {
      marginHorizontal: 60,
      marginTop: 31,
      flex: 1,
      paddingBottom: 50,
    },
    wrap: {
      width: '100%',
      paddingTop: 40,
    },
    controls: {
      ...stylePatterns.flexCenterHorizontal,
      paddingTop: 20,
    },

    loadMoreButton: {
      width: 203,
    },
    colBodyMessageText: {
      ...theme.fonts.h6Light,
      color: theme.color.textColor,
    },
    colBodyMessageTextNotRead: {
      ...theme.fonts.h6,
      color: theme.color.textColor,
    },
    colBodyText: {
      ...theme.fonts.h5Light,
      color: theme.color.labelText,
    },
    colBodyTextNotRead: {
      // ...theme.fonts.action,
      // color: theme.color.textColor,
      ...theme.fonts.h5Light,
      color: theme.color.labelText,
    },
    icon: {
      height: 12,
      width: 12,
      color: theme.color.primaryColor,
    },
    colState: {
      flexBasis: 92,
      alignItems: 'center',
      justifyContent: 'center',
    },
    colText: {
      marginRight: 20,
      flexGrow: 1,
      flexShrink: 1,
    },
    colDate: {
      flexBasis: 107,
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 20,
    },
    colStatus: {
      flexBasis: 203,
    },
    colTime: {
      flexBasis: 92,
      alignItems: 'center',
      justifyContent: 'center',
    },
    titleWrapper: {
      marginBottom: 30,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'relative',
      zIndex: 2,
    },
    visuallyImpairedFilter: {
      marginBottom: 30,
    },
    contentStyle: {
      width: 862,
      minWidth: '65%',
    },
    cardVisuallyImpaired: {top: 54},
    contentStyleModalApplication: {
      paddingTop: 0,
    },
    modalTitle: {
      paddingTop: 20,
      ...theme.fonts.h3,
    },
    modalWrap: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingHorizontal: 0,
      overflow: 'hidden',
      width: 878,
      margin: Platform.OS === 'ios' ? 1 : 0,
    },
    modal: {
      position: 'absolute',
      top: '-5rem',
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 100,
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
    },
  }));

  const columns: Column<ProvidingListApplication>[] = [
    // {
    //   title: '',
    //   render: () => {
    //     const isRead = true; // application.isRead;
    //     return (
    //       <View style={styles.icon}>
    //         {isRead ? (
    //           <images.NotCheckRound width={styles.icon.width} height={styles.icon.height} color={styles.icon.color} />
    //         ) : (
    //           <images.CheckRound width={styles.icon.width} height={styles.icon.height} color={styles.icon.color} />
    //         )}
    //       </View>
    //     );
    //   },
    //   field: 'id',
    //   headStyles: {
    //     colHeadStyle: styles.colState,
    //   },
    //   styles: {
    //     colBodyStyle: styles.colState,
    //   },
    // },
    {
      title: 'Тип заявления',
      titleTestID: 'request-type-header-id',
      render: (application) => {
        const isRead = true; // application.isRead;
        return (
          <TouchableOpacity
            testID={`application-${application.id}-id`}
            onPress={() => onPressItem(application)}
            {...{dataSet: {class: 'link'}}}>
            <Text
              {...{dataSet: {class: 'applications-item-row__type'}}}
              style={isRead ? styles.colBodyMessageText : styles.colBodyMessageTextNotRead}>
              {`${capitalize(application.typeApplicationName)}${
                application.isChildApplication ? ' ребенку (законный представитель)' : ''
              }`}
            </Text>
          </TouchableOpacity>
        );
      },
      field: 'typeApplicationName',
      headStyles: {
        colHeadStyle: styles.colText,
      },
      styles: {
        colBodyStyle: styles.colText,
      },
    },
    {
      title: 'Статус',
      titleTestID: 'request-status-header-id',
      render: (application) => {
        const isRead = true; // application.isRead;
        return (
          <Text
            style={[
              isRead ? styles.colBodyText : styles.colBodyTextNotRead,
              {
                color:
                  _theme.applications.statusColors[
                    (application.statusId as ProfileApplicationsStatus) || ProfileApplicationsStatus.accepted
                  ],
              },
            ]}>
            {application.statusName}
          </Text>
        );
      },
      field: 'statusName',
      headStyles: {
        colHeadStyle: styles.colStatus,
      },
      styles: {
        colBodyStyle: styles.colStatus,
      },
    },
    {
      title: 'Дата подачи',
      titleTestID: 'request-date-filig-header-id',
      render: (application) => {
        const isRead = true; // application.isRead;
        return (
          <Text style={isRead ? styles.colBodyText : styles.colBodyTextNotRead}>
            {datePipe(application.dateTimeFiling)}
          </Text>
        );
      },
      field: 'dateTimeFiling',
      headStyles: {
        colHeadStyle: styles.colDate,
      },
      styles: {
        colBodyStyle: styles.colDate,
      },
    },
    {
      title: 'Время',
      titleTestID: 'request-time-header-id',
      render: (application) => {
        const isRead = true; // application.isRead;
        return (
          <Text style={isRead ? styles.colBodyText : styles.colBodyTextNotRead}>
            {datePipe(application.dateTimeFiling, dateFormats.time)}
          </Text>
        );
      },
      field: 'dateTimeFiling',
      headStyles: {
        colHeadStyle: styles.colTime,
      },
      styles: {
        colBodyStyle: styles.colTime,
      },
    },
  ];

  const navigation = useNavigation();
  const [esiaRegStep, setEsiaRegStep] = useState(EsiaRegStep.UsersList);
  const {addData} = useRegCardState();
  const dispatch = useDispatch();

  const title = useMemo(
    () => (esiaRegStep === EsiaRegStep.DeliveryType ? 'Выбрать способ получения' : 'Оформление нефинансовой ЕСК'),
    [esiaRegStep],
  );
  const modals = useModal();

  const RegStepComponent = useMemo(() => {
    switch (esiaRegStep) {
      case EsiaRegStep.UsersList:
        return <UserCardList onClose={() => {}} onEsiaSubmit={() => setEsiaRegStep(EsiaRegStep.Form)} />;
      case EsiaRegStep.Form:
        return <EsiaRegCardFormScreen onEsiaSubmit={() => setEsiaRegStep(EsiaRegStep.DeliveryType)} />;
      case EsiaRegStep.DeliveryType:
        return <EsiaRegCardMap onGoBack={() => setEsiaRegStep(EsiaRegStep.Form)} navigation={navigation} />;
      default:
        return null;
    }
  }, [esiaRegStep]);

  useEffect(() => {
    showEsiaRegistrationInfoModal();
  }, [esiaRegStep]);

  //@ts-ignore
  const appReduxForms = useSelector((state) => state.form);
  useEffect(() => {
    return () => {
      Object.keys(appReduxForms).forEach((form) => dispatch(destroy(form)));
    };
  }, [esiaRegStep === EsiaRegStep.Form]);

  const showEsiaRegistrationInfoModal = React.useCallback(() => {
    modals.show({
      render(params, methods) {
        return (
          <Modal
            onClose={() => {
              setEsiaRegStep(EsiaRegStep.UsersList);
              methods.remove(params.id);
            }}
            title={title}
            contentStyle={styles.contentStyleModalApplication}
            titleStyle={styles.modalTitle}
            wrapStyle={styles.modalWrap}
            rootStyle={styles.modal}>
            <View style={{maxHeight: '70dvh'}}>
              <CustomScrollView
                withRefresh={false}
                contentInsetAdjustmentBehavior='automatic'
                children={RegStepComponent}
              />
            </View>
          </Modal>
        );
      },
    });
  }, [modals, esiaRegStep]);

  const link = useSelector(esiaLinkSelector);

  const esiaRegInfo = useSelector(esiaRegistrationInfoSelector);

  const onRegCardClick = async () => {
    if (!esiaRegInfo) {
      store.dispatch(showLoaderSlice.actions.setShowing(true));
      saveLoadingState(true, 'ЗАГРУЗКА ДАННЫХ С ГОС УСЛУГ...');
      await dispatch(getEsiaLink({showError: false}));
    } else {
      showEsiaRegistrationInfoModal();
    }
  };

  useEffect(() => {
    if (link != null) window.open(link, '_self');
  }, [link]);

  useEffect(() => {
    if (esiaRegInfo) {
      addData(esiaRegInfo as any);
      dispatch(loginSlice.actions.setEsiaCode(null));
      showEsiaRegistrationInfoModal();
      store.dispatch(showLoaderSlice.actions.setShowing(false));
      clearLoadingState();
    }
  }, [esiaRegInfo]);

  return (
    <Screen>
      <View style={styles.container}>
        <ContentWithRightImageDesktopProfile
          iconStyle={isVisuallyImpaired ? styles.cardVisuallyImpaired : {}}
          contentStyle={styles.contentStyle}
          icon={<CardInfo />}
          hideImage={true}
          btnTitle='Создать заявление'
          btnType='applicationsMenu'
          cardRegInit={onRegCardClick}>
          <View style={styles.wrap}>
            <View style={styles.titleWrapper}>
              <Text testID='show-requests-desktop-label-id' style={styles.h2}>
                Мои заявления
              </Text>
              <View style={{marginLeft: 'auto', flexDirection: 'row'}}>
                {applications?.some((a) => a.statusId === 4) ? (
                  <Button
                    id='profile-applications-more'
                    style={styles.loadMoreButton}
                    onPress={() => {}}
                    text='Подать заявление'
                    type='secondary'
                  />
                ) : null}
                {!isVisuallyImpaired && !!applications?.length ? (
                  <ApplicationsFilterDesktop onSubmit={onApplyFilter} />
                ) : null}
              </View>
            </View>
            {isVisuallyImpaired ? (
              <View style={styles.visuallyImpairedFilter}>
                <ApplicationsFilterVisuallyImpaired onSubmit={onApplyFilter} />
              </View>
            ) : null}
            {!!applications && !applications.length ? (
              <Text testID='no-requests-desktop-label-id'>Заявления отсутствуют</Text>
            ) : null}
            {!applications || !!applications?.length ? <Table data={applications} columns={columns} /> : null}
            <View style={styles.controls}>
              {!allShown ? (
                <Button
                  id='profile-applications-more'
                  style={styles.loadMoreButton}
                  onPress={onLoadMore}
                  text='Показать еще'
                  type='secondary'
                />
              ) : null}
            </View>
          </View>
        </ContentWithRightImageDesktopProfile>
      </View>
    </Screen>
  );
};
